module.exports = __webpack_public_path__ + "../resources/img/storebadge_ko.27a03284.svg";